export default __webpack_public_path__ + "static/fb_landing-9de404d853af9dc254056ab13e597dcd.png";